<template>
  <section class="container-fluid image-bg py-6 py-md-8" id="careers">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-6">
        <h1 class="white-text text-md-center mb-3">Career Opportunities</h1>
        <h2 class="subhead gold-text text-md-center">Join Our Team</h2>
        <hr class="center mt-3 mb-5" />
        <p>
          CSCA actively recruits current industry professionals and graduating
          undergraduate and graduate students for its advisory and asset
          management business. Our goal is to attract, retain and develop the
          best and brightest in our industry. We foster a culture of partnership
          and seek individuals who are passionate about our business and are a
          fit both culturally and professionally.
        </p>
        <p>
          We are committed to developing our internal talent and to promote
          personal growth and success. All applicants must have strong corporate
          finance and accounting backgrounds. Applicants must also have strong
          written and verbal communication skills and be able to manage time
          effectively. Applicants are also expected to be highly proficient with
          using Microsoft Office applications.
        </p>
        <p>
          Applicants with US work authorization from all academic backgrounds
          will be considered.
        </p>
      </div>
      <div class="col-12 text-center">
        <hr class="center my-5" />
        <h3 class="subhead gold-text mb-5">
          Want to Learn More About a Career at CSCA?
        </h3>
        <router-link :to="{ name: 'Contact' }" class="btn -hollow_white"
          >Contact Us</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#careers {
  background-image: url(../assets/meeting-bg.jpg);
  p,
  ul {
    color: #ffffff;
  }
}
h3 {
  color: #ffffff;
  margin-bottom: 1.5rem;
  &.gold-text {
    color: #dcb249;
  }
}
hr {
  width: 150px;
  margin: 1rem 0;
  &.center {
    margin: 0 auto;
  }
}
</style>
